import type {
  MonitoringFrontendErrorMutation,
  MonitoringFrontendErrorMutationVariables,
} from '@/shared/api/__generated__/graphql';
import type { MonitoringFrontendErrorInput } from '@/shared/api/__generated__/schema-types';
import MONITORING_FRONTEND_ERROR_MUTATION from '../mutations/monitoringFrontendError';
import createClient from '../apolloClient';

/**
 * Reports a frontend runtime error to the backend monitoring endpoint. Sends the monitoringFrontendError mutation with the payload and throws the returned message when the mutation does not report success.
 *
 * @param input - Error payload forwarded to the monitoring mutation.
 * @returns Resolves when the error was accepted by the backend.
 */
const handleMonitoringFrontendError = async (input: MonitoringFrontendErrorInput) => {
  const client = createClient();
  const result = await client.mutate<
    MonitoringFrontendErrorMutation,
    MonitoringFrontendErrorMutationVariables
  >({
    mutation: MONITORING_FRONTEND_ERROR_MUTATION,
    variables: {
      input,
    },
  });
  if (!result?.data?.monitoringFrontendError?.isSuccess) {
    throw new Error(result?.data?.monitoringFrontendError?.message ?? undefined);
  }
};

export default handleMonitoringFrontendError;
